import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TarefasEmpresaService } from '../services/tarefas-empresa.service';
import { ModulosBuscaService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';
import { FiltroSelectComponent, FiltroSelectOption } from 'src/app/shared/components/filtro-select/filtro-select.component';
import { FiltroBuscaTextoComponent } from 'src/app/shared/components/filtro-busca-texto/filtro-busca-texto.component';
import { PaginacaoTarefasComponent } from 'src/app/shared/components/paginacao-tarefas/paginacao-tarefas.component';
import { CommonLoaderComponent } from 'src/app/shared/components/common-loader/common-loader.component';
import { PageHeroComponent } from 'src/app/shared/components/page-hero/page-hero.component';
import { CriarTarefaEmpresaComponent } from 'src/app/shared/components/modais-tarefas/criar-tarefa-empresa/criar-tarefa-empresa.component';
import { EditarTarefaEmpresaComponent } from 'src/app/shared/components/modais-tarefas/editar-tarefa-empresa/editar-tarefa-empresa.component';
import { FiltroPeriodoComponent } from 'src/app/metricas/components/filtros-metricas/filtro-periodo/filtro-periodo.component';
import { FiltrosAplicadosComponent } from 'src/app/shared/components/filtros-aplicados/filtros-aplicados.component';
import { ThOrdenavelComponent } from 'src/app/shared/components/th-ordenavel/th-ordenavel.component';
import { OrdenacaoTabela } from 'src/app/shared/utils/ordenacao-tabela';
import { TarefaEmpresaRecord, TarefasEmpresaCounters } from '../interfaces/tarefas-empresa.interface';
import { environment } from 'src/environments/environment';
import { FiltroResponsavelComBuscaComponent } from 'src/app/shared/components/filtro-responsavel-com-busca/filtro-responsavel.component';
import {
  ModalMensagemComponent,
  TipoModalMensagem,
} from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';

interface EmpresaTarefas {
  companyId: number;
  companyTradeName: string;
  companyName: string;
  companyLogoImage: string | null;
  city: string;
  state: string;
  tarefas: TarefaEmpresaRecord[];
}

@Component({
  selector: 'app-tarefas-empresa',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    FiltroSelectComponent,
    FiltroResponsavelComBuscaComponent,
    FiltroBuscaTextoComponent,
    FiltroPeriodoComponent,
    PaginacaoTarefasComponent,
    CommonLoaderComponent,
    PageHeroComponent,
    FiltrosAplicadosComponent,
    ThOrdenavelComponent,
    ModalMensagemComponent,
  ],
  templateUrl: './tarefas-empresa.component.html',
  styleUrls: ['./tarefas-empresa.component.scss'],
})
export class TarefasEmpresaComponent implements OnInit {
  totalTarefas = 0;
  totalCompanies = 0;
  counters: TarefasEmpresaCounters = { todas: 0, atrasadas: 0, pendentes: 0, concluidas: 0 };

  abaAtiva = 'todas';
  abas = [
    { key: 'todas', label: 'Todas as tarefas' },
    { key: 'atrasadas', label: 'Atrasadas' },
    { key: 'pendentes', label: 'Pendentes' },
    { key: 'concluidas', label: 'Concluídas' },
  ];

  filtros = {
    targetCompanyID: 0,
    responsibleID: 0,
    actionID: 0,
    moduleID: 0,
    dateBegin: null as string | null,
    dateEnd: null as string | null,
    situation: 'todas',
    name: null as string | null,
  };

  page = 1;
  pageSize = 50;
  pageLast = 1;
  recordsCount = 0;

  empresas: FiltroSelectOption[] = [{ value: 0, label: 'Todas as empresas' }];
  responsaveis: FiltroSelectOption[] = [{ value: 0, label: 'Todos os responsáveis' }];
  acoes: FiltroSelectOption[] = [{ value: 0, label: 'Todos os tipos de tarefa' }];
  modulos: FiltroSelectOption[] = [
    { value: 0, label: 'Todos os módulos' },
    { value: 234, label: 'Imobiliário' },
    { value: 5, label: 'Industrial' },
    { value: 6, label: 'Edificações' },
    { value: 7, label: 'Infraestrutura' },
  ];

  readonly LOGO_BASE_URL: string = environment.BASE_IMG_MERLIM ?? '';

  tarefas: TarefaEmpresaRecord[] = [];
  grupos: EmpresaTarefas[] = [];
  readonly ordenacao = new OrdenacaoTabela({ followUpFormat: 'date' });
  carregando = false;
  intervaloPeriodo: Date[] | null = null;

  modalMensagem: {
    tipo: TipoModalMensagem;
    titulo: string;
    mensagem: string;
    textoConfirmar: string;
    exibirCancelar: boolean;
    corConfirmar?: string;
  } | null = null;
  private acaoConfirmarModal: (() => void) | null = null;

  private readonly _tarefasService = inject(TarefasEmpresaService);
  private readonly _router = inject(Router);
  private readonly _modalService = inject(BsModalService);
  private modalRef?: BsModalRef;

  ngOnInit(): void {
    this.carregarCombos();
    this.carregarTarefas();
  }

  private exibirMensagem(opts: {
    tipo: TipoModalMensagem;
    titulo: string;
    mensagem: string;
    textoConfirmar?: string;
    exibirCancelar?: boolean;
    corConfirmar?: string;
    aoConfirmar?: () => void;
  }): void {
    this.modalMensagem = {
      tipo: opts.tipo,
      titulo: opts.titulo,
      mensagem: opts.mensagem,
      textoConfirmar: opts.textoConfirmar ?? 'OK',
      exibirCancelar: opts.exibirCancelar ?? false,
      corConfirmar: opts.corConfirmar,
    };
    this.acaoConfirmarModal = opts.aoConfirmar ?? null;
  }

  onConfirmarModalMensagem(): void {
    const acao = this.acaoConfirmarModal;
    this.modalMensagem = null;
    this.acaoConfirmarModal = null;
    acao?.();
  }

  onCancelarModalMensagem(): void {
    this.modalMensagem = null;
    this.acaoConfirmarModal = null;
  }

  /**
   * O app-filtro-responsavel carrega a lista sozinho; guardamos aqui só para
   * montar o rótulo da tag de filtro aplicado.
   */
  onResponsaveisCarregados(responsaveis: { id: number; name: string }[]): void {
    this.responsaveis = [
      { value: 0, label: 'Todos os responsáveis' },
      ...responsaveis.map((r) => ({ value: r.id, label: r.name })),
    ];
  }

  carregarCombos(): void {
    this._tarefasService.listarAcoes().subscribe({
      next: (res: any) => {
        const lista = (res?.data ?? []).map((a: any) => ({ value: Number(a.actionId), label: a.description }));
        this.acoes = [{ value: 0, label: 'Todos os tipos de tarefa' }, ...lista];
      },
      error: () => {},
    });

    this._tarefasService.listTaskCompanies().subscribe({
      next: (res: any) => {
        const lista = (res?.data ?? []).map((e: any) => ({
          value: Number(e.companyId),
          label: e.tradeName || e.name,
        }));
        this.empresas = [{ value: 0, label: 'Todas as empresas' }, ...lista];
      },
      error: () => {},
    });
  }

  selecionarAba(aba: string): void {
    this.abaAtiva = aba;
    this.filtros.situation = aba;
    this.page = 1;
    this.carregarTarefas();
  }

  onFiltroChange(): void {
    this.page = 1;
    this.carregarTarefas();
  }

  onBuscaChange(nome: string): void {
    this.filtros.name = nome || null;
    this.page = 1;
    this.carregarTarefas();
  }

  onPeriodoChange(intervalo: { periodBegin: string; periodEnd: string } | null): void {
    this.filtros.dateBegin = intervalo?.periodBegin ?? null;
    this.filtros.dateEnd = intervalo?.periodEnd ?? null;
    this.page = 1;
    this.carregarTarefas();
  }

  get tagsFiltros(): { key: string; label: string }[] {
    const tags: { key: string; label: string }[] = [];

    const rotulo = (opcoes: FiltroSelectOption[], valor: number) =>
      opcoes.find((o) => o.value === valor)?.label ?? '';

    if (this.filtros.targetCompanyID) {
      tags.push({
        key: 'targetCompanyID',
        label: rotulo(this.empresas, this.filtros.targetCompanyID),
      });
    }
    if (this.filtros.responsibleID) {
      tags.push({
        key: 'responsibleID',
        label: rotulo(this.responsaveis, this.filtros.responsibleID),
      });
    }
    if (this.filtros.moduleID) {
      tags.push({ key: 'moduleID', label: rotulo(this.modulos, this.filtros.moduleID) });
    }
    if (this.filtros.actionID) {
      tags.push({ key: 'actionID', label: rotulo(this.acoes, this.filtros.actionID) });
    }
    if (this.filtros.dateBegin && this.filtros.dateEnd) {
      tags.push({
        key: 'periodo',
        label: `${this.formatarData(this.filtros.dateBegin)} - ${this.formatarData(this.filtros.dateEnd)}`,
      });
    }
    if (this.filtros.name) {
      tags.push({ key: 'name', label: `"${this.filtros.name}"` });
    }

    return tags;
  }

  get temFiltrosAplicados(): boolean {
    return this.tagsFiltros.length > 0 || this.abaAtiva !== 'todas';
  }

  get todosFiltrosSelecionados(): boolean {
    return (
      !!this.filtros.targetCompanyID &&
      !!this.filtros.responsibleID &&
      !!this.filtros.moduleID &&
      !!this.filtros.actionID &&
      !!this.filtros.dateBegin &&
      !!this.filtros.dateEnd &&
      !!this.filtros.name
    );
  }

  private formatarData(data: string): string {
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  removerFiltro(key: string): void {
    switch (key) {
      case 'periodo':
        this.filtros.dateBegin = null;
        this.filtros.dateEnd = null;
        this.intervaloPeriodo = null;
        break;
      case 'name':
        this.filtros.name = null;
        break;
      default:
        (this.filtros as any)[key] = 0;
    }

    this.page = 1;
    this.carregarTarefas();
  }

  limparFiltros(): void {
    this.filtros = {
      ...this.filtros,
      targetCompanyID: 0,
      responsibleID: 0,
      actionID: 0,
      moduleID: 0,
      dateBegin: null,
      dateEnd: null,
      name: null,
    };
    this.intervaloPeriodo = null;
    this.page = 1;
    this.carregarTarefas();
  }

  carregarTarefas(): void {
    this.carregando = true;

    const body = {
      ...this.filtros,
      pagination: { page: this.page, pageSize: this.pageSize, shortcuts: 10 },
    };

    this._tarefasService.listarTarefas(body).subscribe({
      next: (res: any) => {
        const data = res?.data ?? {};
        this.counters = data.counters ?? { todas: 0, atrasadas: 0, pendentes: 0, concluidas: 0 };
        this.totalCompanies = data.totalCompanies ?? 0;
        const paginacao = data.tasks ?? {};
        this.tarefas = paginacao.records ?? [];
        this.recordsCount = paginacao.recordsCount ?? 0;
        this.pageLast = paginacao.pageLast ?? 1;
        this.totalTarefas = this.counters[this.abaAtiva as keyof TarefasEmpresaCounters] ?? 0;
        this.agruparTarefas();
        this.carregando = false;
      },
      error: () => {
        this.tarefas = [];
        this.grupos = [];
        this.carregando = false;
      },
    });
  }

  agruparTarefas(): void {
    const mapa = new Map<number, EmpresaTarefas>();

    for (const tarefa of this.tarefas) {
      if (!mapa.has(tarefa.companyId)) {
        mapa.set(tarefa.companyId, {
          companyId: tarefa.companyId,
          companyTradeName: tarefa.companyTradeName,
          companyName: tarefa.companyName,
          companyLogoImage: tarefa.companyLogoImage ?? null,
          city: tarefa.city,
          state: tarefa.state,
          tarefas: [],
        });
      }
      mapa.get(tarefa.companyId)!.tarefas.push(tarefa);
    }

    this.grupos = Array.from(mapa.values());
    this.aplicarOrdenacao();
  }

  ordenarPor(coluna: string): void {
    this.ordenacao.alternar(coluna);
    this.aplicarOrdenacao();
  }

  private aplicarOrdenacao(): void {
    if (!this.ordenacao.coluna) return;

    this.grupos = this.grupos.map((grupo) => ({
      ...grupo,
      tarefas: this.ordenacao.aplicar(grupo.tarefas),
    }));
  }

  onPageChange(page: number): void {
    this.page = page;
    this.carregarTarefas();
  }

  abrirEmpresa(empresa: EmpresaTarefas): void {
    this._router.navigate(['/empresas/detalhes', 'imobiliario', empresa.companyId]);
  }

  iniciais(nome: string): string {
    return (nome ?? '').trim().substring(0, 2).toUpperCase();
  }

  logoUrl(empresa: EmpresaTarefas): string {
    return `${this.LOGO_BASE_URL}${empresa.companyLogoImage}`;
  }

  /**
   * Cor da tag por tipo de ação. Sem match, distribui uma das cores neutras
   * de forma estável (mesma ação => mesma cor).
   */
  classeAcao(acao: string): string {
    const a = (acao ?? '').toLowerCase();

    if (a.includes('ligaç') || a.includes('ligac') || a.includes('telefon')) return 'acao-ligacao';
    if (a.includes('e-mail') || a.includes('email')) return 'acao-email';
    if (a.includes('visita')) return 'acao-visita';
    if (a.includes('reuni')) return 'acao-reuniao';
    if (a.includes('propost') || a.includes('orçament') || a.includes('orcament')) return 'acao-proposta';
    if (a.includes('whats')) return 'acao-whatsapp';

    const indice = [...a].reduce((soma, char) => soma + char.charCodeAt(0), 0) % 4;
    return `acao-neutra-${indice + 1}`;
  }

  classeStatus(status: string): string {
    const s = (status ?? '').toLowerCase();
    if (s.includes('atrasad')) return 'atrasada';
    if (s.includes('pendent')) return 'pendente';
    if (s.includes('conclu')) return 'concluida';
    return '';
  }

  concluirTarefa(tarefa: TarefaEmpresaRecord): void {
    this._tarefasService.alterarStatus(tarefa.taskId, 3).subscribe({
      next: () => {
        this.carregarTarefas();
        this.exibirMensagem({
          tipo: 'sucesso',
          titulo: 'Sucesso!',
          mensagem: 'Tarefa concluída com sucesso!',
        });
      },
      error: (err) =>
        this.exibirMensagem({
          tipo: 'erro',
          titulo: 'Erro',
          mensagem: err?.error?.message ?? 'Não foi possível concluir a tarefa.',
        }),
    });
  }

  excluirTarefa(tarefa: TarefaEmpresaRecord): void {
    this.exibirMensagem({
      tipo: 'confirmacao',
      titulo: 'Excluir tarefa',
      mensagem: 'Deseja realmente excluir esta tarefa?',
      textoConfirmar: 'Excluir',
      exibirCancelar: true,
      corConfirmar: '#d32f2f',
      aoConfirmar: () => {
        this._tarefasService.excluirTarefa(tarefa.taskId).subscribe({
          next: () => {
            if (this.tarefas.length === 1 && this.page > 1) {
              this.page--;
            }

            this.carregarCombos();
            this.carregarTarefas();

            this.exibirMensagem({
              tipo: 'sucesso',
              titulo: 'Sucesso!',
              mensagem: 'Tarefa excluída com sucesso!',
            });
          },
          error: (err) =>
            this.exibirMensagem({
              tipo: 'erro',
              titulo: 'Erro',
              mensagem: err?.error?.message ?? 'Não foi possível excluir a tarefa.',
            }),
        });
      },
    });
  }

  editarTarefa(tarefa: TarefaEmpresaRecord): void {
    this.modalRef = this._modalService.show(EditarTarefaEmpresaComponent, {
      class: 'modal-md',
      initialState: { tarefa },
    });

    const componente = this.modalRef.content as EditarTarefaEmpresaComponent;
    componente.tarefaEditada.subscribe(() => this.carregarTarefas());
    componente.fechar.subscribe(() => this.modalRef?.hide());
  }

    criarTarefa(): void {
    this.modalRef = this._modalService.show(CriarTarefaEmpresaComponent, {
      class: 'modal-md',
      initialState: {
        selecionarEmpresa: true,
      },
    });

    const componente = this.modalRef.content as CriarTarefaEmpresaComponent;

    componente.tarefaCriada.subscribe(() => {
      this.carregarTarefas();
      this.modalRef?.hide();
    });

    componente.fechar.subscribe(() => this.modalRef?.hide());
  }
}
